import {Izbor} from "../../../komponente/izbor/Izbor";
import podaci from './pripreme.json';

export default class extends Izbor {

  constructor() {
    super(podaci);
    this.podaciFajl = 'pripreme.json'
  }

}



// WEBPACK FOOTER //
// ./src/hronologija/1941/05-15/pripreme.js